import { render } from "./User.vue?vue&type=template&id=28fb815e&scoped=true"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"

import "./User.vue?vue&type=style&index=0&id=28fb815e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-28fb815e"

export default script